import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Chip, useTheme } from "@mui/material";
import { ClampedTypography } from "../../Typographies/ClampedTypography";
import { getChipText } from "../utils/addressCardUtils";
export const NameAndChipComponent = ({ isPrimaryAddress, isDeliveryAddressCard, name, city, }) => {
    const theme = useTheme();
    const isChipDisplayed = (isPrimaryAddress && isDeliveryAddressCard) || (!isDeliveryAddressCard && !!city);
    const chipText = getChipText(isPrimaryAddress, isDeliveryAddressCard, city);
    return (_jsxs(Box, Object.assign({ display: "flex", gap: 0.5, justifyContent: "space-between", alignItems: "baseline", marginBottom: 1.5, minHeight: theme.typography.pxToRem(36) }, { children: [_jsx(ClampedTypography, Object.assign({ lines: 1, variant: "h4" }, { children: name })), isChipDisplayed && chipText && (_jsx(Chip, { label: chipText, color: "primary", variant: "outlined", style: {
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.text.primary,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    minWidth: theme.typography.pxToRem(90),
                } }))] })));
};
